import { useState } from 'react'
import { Checkbox, Popover, Typography } from 'antd'
import CustomAntButton from '../Button/CustomAntButton'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'

export const getSearchFieldPlaceholder = (fields, groups, value = []) => {
  const fieldGroups = groups?.length ? groups : [{ fields }]
  const selectedValues = [...new Set(value)]
  const selectedGroup =
    fieldGroups.find((group) =>
      group.fields.some(({ value: fieldValue }) =>
        selectedValues.includes(fieldValue),
      ),
    ) ?? fieldGroups[0]
  const labels = selectedGroup?.fields
    .filter(({ value: fieldValue }) => selectedValues.includes(fieldValue))
    .map(({ label }) => label)

  return labels?.length ? `Nhập ${labels.join(', ')} để tìm` : 'Nhập để tìm'
}

export default function SearchFieldPopover({
  fields = [],
  groups,
  value = [],
  onChange,
}) {
  const [isOpen, setIsOpen] = useState(false)

  const selectedValues = [...new Set(value)]
  const fieldGroups = groups?.length ? groups : [{ fields }]
  const selectedGroup =
    fieldGroups.find((group) =>
      group.fields.some(({ value: fieldValue }) =>
        selectedValues.includes(fieldValue),
      ),
    ) ?? fieldGroups[0]
  const activeValues = selectedValues.filter((selectedValue) =>
    selectedGroup?.fields.some(({ value: fieldValue }) =>
      fieldValue === selectedValue,
    ),
  )
  const activeLabels =
    selectedGroup?.fields
      .filter(({ value: fieldValue }) => activeValues.includes(fieldValue))
      .map(({ label }) => label) ?? []

  const handleChange = (values) => {
    if (!values.length) return

    onChange?.([...new Set(values)])
  }

  const handleTogglePopover = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <KTTooltip
      text={
        <div>
          <div>
            Nhấn vào đây để thay đổi thông tin cần tìm kiếm. Đang thiết lập tìm
            kiếm theo:{' '}
            {activeLabels.length
              ? activeLabels.join(', ')
              : 'Chưa chọn trường nào'}
          </div>
        </div>
      }
    >
      <span>
        <Popover
          open={isOpen}
          onOpenChange={setIsOpen}
          trigger="click"
          placement="bottomLeft"
          content={
            <div style={{ width: 220, maxHeight: 320, overflowY: 'auto' }}>
              <Typography.Title level={5} style={{ margin: '0 0 12px' }}>
                Tìm kiếm theo
              </Typography.Title>

              {fieldGroups.map((group, index) => (
                <div
                  key={group.key ?? index}
                  style={{
                    ...(index > 0
                      ? {
                          borderTop: '1px solid #d9e0e8',
                          marginTop: 8,
                          paddingTop: 8,
                        }
                      : {}),
                  }}
                >
                  <Checkbox.Group
                    options={group.fields}
                    value={group === selectedGroup ? activeValues : []}
                    onChange={handleChange}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 8,
                    }}
                  />
                </div>
              ))}
            </div>
          }
        >
          <CustomAntButton
            iconCn="fa-regular fa-gear"
            antProps={{
              type: 'default',
              className: 'p-3',
              shape: 'round',
              onClick: handleTogglePopover,
            }}
            customStyle={{
              minWidth: 'fit-content',
            }}
          />
        </Popover>
      </span>
    </KTTooltip>
  )
}
